module.exports = __webpack_public_path__ + "media/PhotoIcon.a3af65e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/PhotoIcon.svg
// module id = 770
// module chunks = 0